<template>

    <div class="wrap">
        <div class="wrappedContent">

            <div class="narrowHeader resultHeader">
                <h2>
                    人生100年を見据えた<br>
                    収支とライフイベント
                </h2>
            </div>

            <GraphShinchiku :calc="calc" :mochiie="mochiie" :mochiieNuri="mochiieNuri" :shuunyuu="shuunyuu" :shishutsu="shishutsu" :life-event-list="lifeEventList"></GraphShinchiku>


            <!-- 住宅ローン支払額 -->
            <LoanPaymentBar v-if="calc.mochiieTotalLoanPayment"
                :calc="calc" :mochiie="mochiie" :mochiieNuri="mochiieNuri" :shuunyuu="shuunyuu" :shishutsu="shishutsu" :life-event-list="lifeEventList"></LoanPaymentBar>

            <!-- 支払い期間:教育費 -->
            <div class="bouBox" ref="shuushiBox">
                <div class="clearfix kyouikuhiKikan" v-for="(item,index) in kyouikuhis" :key="index">
                    <div class="bou-child-vline">
                        <p class="bou_title">
                            第{{ index + 1 }}子
                            <span class="school-ladder">{{ item.schoolLadder }}</span>
                        </p>
                    </div>
                    <div class="bou-child" v-if="item.shishutsu>0" :style="'width:'+item.width+'px;left:'+item.left+'px;'">
                        <p class="bou_title kingaku" v-if="item.width>120">{{ manYenToOkuYen(item.shishutsu) }}万円</p>
                        <div class="bou-child_arrow"></div>
                    </div>
                    <p class="bou_title kingaku outer" v-if="item.width<=120">{{ manYenToOkuYen(item.shishutsu) }}万円</p>
                </div>
            </div>

            <!-- 支払い期間:収入累計額 -->
            <div class="bouBox">
                <div class="bouInner setaishuunyuu">
                    <p class="bou_title"><span class="circle-no-text">1</span>収入累計額</p>
                    <p class="bou_title kingaku">{{ manYenToOkuYen(calc.setaiTotalShuunyuu) }}万円</p>
                </div>
            </div>

            <!-- 支払い期間:支出総額 -->
            <div class="bouBox">
                <div class="bouInner seikatsuhi">
                    <p class="bou_title"><span class="circle-no-text">2</span>支出総額</p>
                    <p class="bou_title kingaku">{{ seikatsuhiSougaku }}万円</p>
                </div>
            </div>

            <!-- トールタル収支 -->
            <MainCopy :shushi="totalShushi" :is-shinchiku="isShinchiku"></MainCopy>

            <!-- 注釈 -->
            <div class="calc-notice">
                本試算は住宅ローン減税や補助金、メンテナンス費用は考慮しておりません。<br>
                詳しいシミュレーションをご希望の方は「<a href="#shikin-soudan" class="calc-notice-link">資金相談</a>」よりお申込みください。
            </div>


            <!--アドバイス-->
            <Advice :calc="calc" :is-shinchiku="isShinchiku" :shushi-list="calc.mochiieShushi" :kansai-nenrei="kansaiNenrei" v-show="displayInputCheck"></Advice>

            <!--ライフイベント-->
            <LifeEvent :calc="calc" :life-event-list="lifeEventList" v-show="displayInputCheck"></LifeEvent>

            <!-- ミサワホームからのご提案 -->
            <MisawaPromotion></MisawaPromotion>

            <!--おすすめのお役立ちメニュー -->
            <Footer class="d-flex"></Footer>

            <!--入力情報、計算根拠-->
            <InputData></InputData>

            <div class="disclaimer">
                <h4>【免責事項】</h4>
                <ul>
                    <li>・本シミュレーションは、過去のデータ等に基づいて試算を行うもので、実際値とは異なる場合があります。</li>
                    <li>・本シミュレーションのいかなる内容も、将来の結果を予測し、保証するものではありません。</li>
                    <li>・本シミュレーションは、ご入力いただいたおおよその収入や支出条件等をもとに将来の資金計画や生活設計のサポートを行う為の情報提供を目的としています。<br>
                        試算された診断結果はあくまでも目安としてご利用ください。</li>
                    <li>・情報の正確性には万全を期しておりますが、その内容の正確性、完全性、信頼性等を保証するものではありません。</li>
                    <li>・本シミュレーションの内容については、予告なく変更される場合があります。</li>
                </ul>

            </div>

        </div>

    </div>

</template>




<script>

import MainCopy from "./result/MainCopy";
import GraphShinchiku from "./result/GraphShinchiku";
import shushiCalc from '@/store/shushiCalc.js';
import Advice from "./result/Advice";
import LifeEvent from "./result/LifeEvent";
import MisawaPromotion from "./result/MisawaPromotion";
import InputData from "./result/InputData";
import Footer from "./result/Footer";


import CalcUtil from "@/store/calcUtil.js"
import LoanPaymentBar from "./result/LoanPaymentBar";

export default {
    name: "result.vue",
    components: {
        LoanPaymentBar,
        MainCopy,
        GraphShinchiku,
        Advice,
        LifeEvent,
        MisawaPromotion,
        InputData,
        Footer,
    },
    data() {
        return {
            calc: {},
            mochiie: [],
            mochiieNuri: [],
            shuunyuu: [],
            shishutsu: [],
            kyouikuhis: []
        }
    },
    computed: {
        ageStart () {
            return this.$store.state.setainushi.age * 1 //storeを読む
        },
        mochiieRatio(){
            let start = this.ageStart;
            let kansai = start+35;
            return this.agePosition(kansai);
        },
        mochiieWidth(){
            return (this.mochiieRatio * 100) +"%";
        },
        seikatsuhiSougaku(){
            return this.manYenToOkuYen(this.calc.setaiTotalShishutsu);
        },
        totalShushi() {
            return this.calc.setaiTotalShuunyuu - this.calc.setaiTotalShishutsu;
        },
        isShinchiku(){
            return this.$store.state.osumai.plan != 2;
        },
        kansaiNenrei(){
            if(typeof(this.calc.kansaiNenrei) == "function"){
                return this.calc.kansaiNenrei();
            }
            return 1;
        },
        lifeEventList() {
            let eventList = [];

            //2. 大学卒業
            //calc.okosamaAges の お子様 の年齢リストから 22歳を大学卒業として計算する
            let i=1;
            this.calc.okosamaAges.forEach(okosama=>{

                let graduationInfo = {
                    age: 22,
                    text: '大学',
                };
                if (okosama.school == 1){ //高校
                    graduationInfo.age = 18;
                    graduationInfo.text = '高校';
                }

                if (okosama.age > graduationInfo.age) {
                    return; //既に卒業している場合は、イベントにしない
                }

                if (okosama.age <= 0) {
                    let tanjouSetainushiAge = this.calc.startAge - okosama.age;

                    let okosamaEvent = {age: tanjouSetainushiAge + '歳', x:tanjouSetainushiAge, y:0, event: '第'+ i +'子 誕生'};
                    eventList.push(okosamaEvent);
                }

                let sotsugyouSetainushiAge = this.calc.startAge + graduationInfo.age - okosama.age;
                let okosamaEvent = {age: sotsugyouSetainushiAge + '歳', x:sotsugyouSetainushiAge, y:0, event: '第'+ i +'子 ' + graduationInfo.text + '卒業'};

                if (this.calc.startAge <= sotsugyouSetainushiAge) {
                    eventList.push(okosamaEvent);
                }

                i += 1;
            });

            //3.定年退職
            if (this.calc.retirementInfo.setainushi.age) {
                let TeinenEventObj = {age: this.calc.retirementInfo.setainushi.age+'歳', x:this.calc.retirementInfo.setainushi.age, y:0, event: '定年退職'};
                eventList.push(TeinenEventObj);
            }


            //4.ローン完済
            if (this.calc.mochiieTotalLoanPayment) {
                let LoanEventObj = {age: this.calc.kansaiNenrei()+'歳', x:this.calc.kansaiNenrei(), y:0, event: 'ローン完済'};
                eventList.push(LoanEventObj);
            }

            //年齢順になるようにソートしている
            eventList = eventList.sort(function(a, b) {
                return (a.age < b.age) ? -1 : 1;  //オブジェクトの昇順ソート
            });

            return eventList;
        },
        displayInputCheck() {
            if (!this.calc.startAge || isNaN(this.calc.mochiieRuisekiShushi)) {
                return false;
            }

            return true;
        }
    },
    methods: {
        agePosition(age){
            let start = this.ageStart;
            let end = 90;

            if (age <= this.ageStart) {
                return 0;
            }

            let p = ((age - start) / (end -start));

            return p;
        },
        setKyouikuhiData(kyouikuhiUchiwake) {

            let parentBox = this.$refs.shuushiBox.getBoundingClientRect();
            // console.log(parentBox);


            this.kyouikuhis = [];
            // let i=0;
            kyouikuhiUchiwake.forEach(okosama=>{
                // console.log(okosama);
                let barData = [];
                barData.shishutsu = okosama.totalPayment;
                barData.left = parentBox.width * this.agePosition(okosama.startSetainushiAge);
                barData.width = parentBox.width * this.agePosition((okosama.endSetainushiAge - okosama.startSetainushiAge) + this.ageStart);

                barData.schoolLadder = okosama.schoolLadder;


                // console.log(barData);

                // this.$set(this.kyouikuhis, i, barData);
                this.kyouikuhis.push(barData);

                // i += 1;
            });

            // this.kyouikuhis = data;

            // return [
            //     {
            //         shishutsu: 2437,
            //         left:0,
            //         width:200,
            //     },
            //     {
            //         shishutsu:4437,
            //         left:90,
            //         width:250,
            //     },
            // ];
        },
        manYenToOkuYen(manYen) {
            return CalcUtil.manYenToOkuYen(manYen);
        },
        createUrlWithQueryParameters(vm) {
            // let url = location.protocol + '//' + location.host + location.pathname;
            // let q = 'p=p1q140q21q340q465q5100p2q11q240q34q4q5p3q11q22q3c1_1c1_2c2_2p4q11q210q313';
            let q = 'p=';
            let params = vm.$store.getters.queryParams;
            q += 'p1q' + params.setainushi.join('q');
            q += 'p2q' + params.haiguusha.join('q');
            q += 'p3q' + params.okosama.join('q');
            q += 'p4q' + params.osumai.join('q');
            return 'result?'+q;
            // return url+'?'+q;
        },
        setStoreFromQueryParameters() {
            // URL?p=p1q140q21q340q465q5100p2q11q240q34q4q5p3q11q22q3c1_1c1_2c2_2p4q11q210q313
            // console.log(this.$route.query.p);
            let param = this.$route.query.p;
            if (!param) {
                return;
            }
            let perPageParam = param.split('p');
            // console.log(perPageParam);
            perPageParam.forEach( pp => { //pp:page param
                if (pp) {
                    let question = pp.split('q');
                    // console.log(question);
                    if (question[0] == '1') {
                        this.$store.commit('setSetainushiFromQueryParameters', question);
                    }
                    else if (question[0] == '2') {
                        this.$store.commit('setHaiguushaFromQueryParameters', question);
                    }
                    else if (question[0] == '3') {
                        this.$store.commit('setOkosamaFromQueryParameters', question);
                    }
                    else if (question[0] == '4') {
                        this.$store.commit('setOsumaiFromQueryParameters', question);
                    }
                }
            });
        }
    },
    created() {
        //URLクエリパラメータの取得
        this.setStoreFromQueryParameters();

        this.calc = new shushiCalc(this.$store);
    },
    mounted() {

        // this.calc = new shushiCalc(this.$store);
        let shusi = this.calc.shusi();

        this.mochiie = shusi[0];
        this.mochiieNuri = shusi[1];
        // this.chintai = shusi[1];

        this.shuunyuu = shusi[2];
        this.shishutsu = shusi[3];

      //教育費のバーを表示するデータを設定してあげる
        this.setKyouikuhiData(this.calc.kyouikuhiUchiwake);


    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            let pageTitle = '住マイライフなび 簡易版 シミュレーション結果';
            let url = vm.createUrlWithQueryParameters(vm);
            // console.log(url);
            // //URLパラメータをもちプロ（Rtoaster）に送信する
            window.Rtoaster.track({'page_title': pageTitle}, url);
        });
    }

}


</script>

<style lang="scss" scoped>

.wrap .wrappedContent {

    .narrowHeader.resultHeader {

        border-bottom: 1px solid #0c436f;
        margin-bottom: 20px;

        h2 {
            color: #0c436f;
            font-size: 30px;
            line-height: 40px;
        }

    }

    .arrow-to-shuushi {
        position: absolute;
        right: 130px;
        padding-top: 58px;
        text-align: center;

        img {
            height: 158px;
        }
    }

}

a{text-decoration:none }
a:hover{ text-decoration:none }


/* 年齢 */
.age-box {
  position: relative;
  height: 30px;

}

/* 棒グラフ */
.bouBox {
    position: relative;
    padding-top: 15px;

    border-left: 1px solid #000;
    border-right: 1px solid #000;

    font-size: 18px;
    font-weight: bold;

    .circle-no-text {
        display: inline-block;
        margin-right: 6px;
        width: 25px;
        height: 25px;
        line-height: 25px;
        border-radius: 50%;
        color: #fff;
        font-size: 18px;
        background: #111;
        text-align:center;
    }

    .kingaku{
        right: 0;
        color: #fff;
        font-size: 23px;
    }

    .bouInner {
        position: relative;
        width: 100%;
        height: 50px;
        color: #000;
    }

    .bou_title {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        -webkit-transform: translateY(-50%);
        padding: 0 10px;
        white-space: nowrap;

    }

    .setaishuunyuu {
        background: linear-gradient(to right, #fff, #92a9d5) !important;
    }
    .seikatsuhi {
        background: linear-gradient(to right, #fff, #0c436f) !important;
    }
    .kyouikuhiKikan{
        font-size: 17px;

        .bou-child-vline {
            position: relative;
            height: 22px;

            .bou_title {
                font-size: 15px;
            }
        }

        .bou_title {
            font-size: 15px;

            &.kingaku {
                font-size: 20px;
                padding-right: 15px;

                &.outer {
                    color: #666;
                    position: relative;
                    transform: none;
                    padding: 0;
                    margin: 0;
                }
            }
        }

        .bou-child{
            position: relative;
            width: 100%;
            height: 30px;
            color: #000;
            background: linear-gradient(to right, #E2F0F2, rgb(0, 159, 168)) !important;
            margin-bottom: 3px;
            margin-right: 5px;
            float: left;


            .bou-child_arrow {
                content: "";
                position: absolute;
                right: 0;
                width: 0;
                height: 30px;
                margin: auto;
                border-style: solid;
                border-color: #fff #fff #fff rgb(0, 159, 168);
                border-width: 15px 0 15px 10px;
                display: block;
            }
        }

        .school-ladder {
            font-size: 13px;
            font-weight: normal;
            margin-left: 10px;
        }

    }

}

.calc-notice {
    position: relative;
    padding: 12px;

    margin-bottom: 20px;

    border-left: 1px solid #000;
    border-right: 1px solid #000;

    width: 100%;

    font-size: 16px;
    line-height: 23px;
    text-align: center;

    a.calc-notice-link {
        text-decoration: underline;
        font-weight: bold;
        color: #0251a7;

        &:hover {
            color: #012b61;
        }
    }
}

.disclaimer {
    font-size: 12px;
    color: #444;

    h4 {
        font-size: 14px;
    }

    ul {
        list-style-type: none;
        padding-left: 6px;
        padding-bottom: 40px;

        li {
            padding-left: 0.9rem;
            text-indent: -0.9rem;
        }
    }
}

@media screen and (max-width: 500px) {

    .arrow-to-shuushi {
        display: none !important;
    }

    .wrap .wrappedContent .narrowHeader {
        padding-top: 0;

        &.resultHeader h2 {
            font-size: 24px;
            line-height: 26px;
        }

    }

}




</style>